export default __webpack_public_path__ + "static/media/lots_cubes_trader.268c4fc2.png";